// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ipkm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 1rem;
}

.ipkm-dialog {
  background: var(--bg-primary, #fff);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.22);
  width: 100%;
  max-width: 440px;
  overflow: hidden;
  animation: ipkm-slide-in 0.2s ease;
}

@keyframes ipkm-slide-in {
  from { transform: translateY(-20px); opacity: 0; }
  to   { transform: translateY(0);     opacity: 1; }
}

/* Header */
.ipkm-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--border-color, #e5e7eb);
  background: var(--bg-secondary, #fafafa);
}

.ipkm-icon {
  font-size: 1.4rem;
  line-height: 1;
}

.ipkm-title {
  flex: 1 1;
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--text-primary, #111);
}

.ipkm-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  color: var(--text-secondary, #666);
  padding: 0 0.25rem;
  transition: color 0.15s;
}
.ipkm-close:hover { color: var(--text-primary, #111); }

/* Body */
.ipkm-body {
  padding: 1.25rem;
}

.ipkm-description {
  margin: 0 0 0.75rem;
  color: var(--text-primary, #111);
  font-size: 0.95rem;
  line-height: 1.55;
}

.ipkm-tip {
  margin: 0 0 1.25rem;
  font-size: 0.85rem;
  color: var(--text-secondary, #666);
  background: var(--bg-secondary, #f9fafb);
  border-left: 3px solid var(--accent-color, #e31337);
  padding: 0.5rem 0.75rem;
  border-radius: 0 6px 6px 0;
}

/* Form */
.ipkm-form {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.ipkm-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-primary, #111);
}

.ipkm-input {
  width: 100%;
  padding: 0.55rem 0.75rem;
  border: 1px solid var(--border-color, #d1d5db);
  border-radius: 8px;
  font-size: 0.95rem;
  background: var(--bg-primary, #fff);
  color: var(--text-primary, #111);
  transition: border-color 0.15s, box-shadow 0.15s;
  box-sizing: border-box;
}
.ipkm-input:focus {
  outline: none;
  border-color: var(--accent-color, #e31337);
  box-shadow: 0 0 0 3px rgba(227, 19, 55, 0.12);
}

.ipkm-error {
  margin: 0;
  color: var(--danger-color, #dc3545);
  font-size: 0.85rem;
}

/* Buttons */
.ipkm-actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.25rem;
}

.ipkm-btn {
  padding: 0.6rem 1rem;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: background 0.15s, opacity 0.15s;
}
.ipkm-btn:disabled { opacity: 0.55; cursor: not-allowed; }

.ipkm-btn-primary {
  background: var(--accent-color, #e31337);
  color: #fff;
}
.ipkm-btn-primary:hover:not(:disabled) {
  background: var(--accent-hover, #c01130);
}

.ipkm-btn-ghost {
  background: transparent;
  color: var(--text-secondary, #666);
  text-decoration: underline;
  font-size: 0.875rem;
}
.ipkm-btn-ghost:hover:not(:disabled) {
  color: var(--text-primary, #111);
}

/* Success state */
.ipkm-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 0;
  text-align: center;
}
.ipkm-success-icon { font-size: 2rem; }
.ipkm-success p {
  margin: 0;
  color: var(--text-primary, #111);
  font-size: 0.95rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/InvalidPostingKeyModal/InvalidPostingKeyModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,OAAO,wBAAwB,MAAM,UAAU,EAAE;AACnD;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,qDAAqD;EACrD,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;AACzB;AACA,oBAAoB,gCAAgC,EAAE;;AAEtD,SAAS;AACT;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,mDAAmD;EACnD,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;EAChC,gDAAgD;EAChD,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,2CAA2C;AAC7C;AACA,qBAAqB,aAAa,EAAE,mBAAmB,EAAE;;AAEzD;EACE,wCAAwC;EACxC,WAAW;AACb;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;AACA,qBAAqB,eAAe,EAAE;AACtC;EACE,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB","sourcesContent":[".ipkm-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  padding: 1rem;\n}\n\n.ipkm-dialog {\n  background: var(--bg-primary, #fff);\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.22);\n  width: 100%;\n  max-width: 440px;\n  overflow: hidden;\n  animation: ipkm-slide-in 0.2s ease;\n}\n\n@keyframes ipkm-slide-in {\n  from { transform: translateY(-20px); opacity: 0; }\n  to   { transform: translateY(0);     opacity: 1; }\n}\n\n/* Header */\n.ipkm-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid var(--border-color, #e5e7eb);\n  background: var(--bg-secondary, #fafafa);\n}\n\n.ipkm-icon {\n  font-size: 1.4rem;\n  line-height: 1;\n}\n\n.ipkm-title {\n  flex: 1;\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: var(--text-primary, #111);\n}\n\n.ipkm-close {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  line-height: 1;\n  cursor: pointer;\n  color: var(--text-secondary, #666);\n  padding: 0 0.25rem;\n  transition: color 0.15s;\n}\n.ipkm-close:hover { color: var(--text-primary, #111); }\n\n/* Body */\n.ipkm-body {\n  padding: 1.25rem;\n}\n\n.ipkm-description {\n  margin: 0 0 0.75rem;\n  color: var(--text-primary, #111);\n  font-size: 0.95rem;\n  line-height: 1.55;\n}\n\n.ipkm-tip {\n  margin: 0 0 1.25rem;\n  font-size: 0.85rem;\n  color: var(--text-secondary, #666);\n  background: var(--bg-secondary, #f9fafb);\n  border-left: 3px solid var(--accent-color, #e31337);\n  padding: 0.5rem 0.75rem;\n  border-radius: 0 6px 6px 0;\n}\n\n/* Form */\n.ipkm-form {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.ipkm-label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-primary, #111);\n}\n\n.ipkm-input {\n  width: 100%;\n  padding: 0.55rem 0.75rem;\n  border: 1px solid var(--border-color, #d1d5db);\n  border-radius: 8px;\n  font-size: 0.95rem;\n  background: var(--bg-primary, #fff);\n  color: var(--text-primary, #111);\n  transition: border-color 0.15s, box-shadow 0.15s;\n  box-sizing: border-box;\n}\n.ipkm-input:focus {\n  outline: none;\n  border-color: var(--accent-color, #e31337);\n  box-shadow: 0 0 0 3px rgba(227, 19, 55, 0.12);\n}\n\n.ipkm-error {\n  margin: 0;\n  color: var(--danger-color, #dc3545);\n  font-size: 0.85rem;\n}\n\n/* Buttons */\n.ipkm-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-top: 0.25rem;\n}\n\n.ipkm-btn {\n  padding: 0.6rem 1rem;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n  border: none;\n  transition: background 0.15s, opacity 0.15s;\n}\n.ipkm-btn:disabled { opacity: 0.55; cursor: not-allowed; }\n\n.ipkm-btn-primary {\n  background: var(--accent-color, #e31337);\n  color: #fff;\n}\n.ipkm-btn-primary:hover:not(:disabled) {\n  background: var(--accent-hover, #c01130);\n}\n\n.ipkm-btn-ghost {\n  background: transparent;\n  color: var(--text-secondary, #666);\n  text-decoration: underline;\n  font-size: 0.875rem;\n}\n.ipkm-btn-ghost:hover:not(:disabled) {\n  color: var(--text-primary, #111);\n}\n\n/* Success state */\n.ipkm-success {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.5rem 0;\n  text-align: center;\n}\n.ipkm-success-icon { font-size: 2rem; }\n.ipkm-success p {\n  margin: 0;\n  color: var(--text-primary, #111);\n  font-size: 0.95rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
